/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import { useState, useEffect } from 'react';
export function useTheme() {
    const [themeMode, setThemeMode] = useState('system');
    const [styleMode, setStyleMode] = useState('tokyo'); 
    const [actualTheme, setActualTheme] = useState('dark');
    useEffect(() => {
        const savedTheme = localStorage.getItem('app-theme') || 'system';
        const savedStyle = localStorage.getItem('app-style') || 'tokyo';
        setThemeMode(savedTheme);
        setStyleMode(savedStyle);
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const updateActualTheme = (mode) => {
            let isDark;
            if (mode === 'system') {
                isDark = mediaQuery.matches;
            } else {
                isDark = mode === 'dark';
            }
            const newActual = isDark ? 'dark' : 'light';
            setActualTheme(newActual);
            document.documentElement.setAttribute('data-theme', newActual);
        };
        const handleSystemChange = () => {
            if (localStorage.getItem('app-theme') === 'system' || !localStorage.getItem('app-theme')) {
                updateActualTheme('system');
            }
        };
        updateActualTheme(savedTheme);
        document.documentElement.setAttribute('data-style', savedStyle);
        mediaQuery.addEventListener('change', handleSystemChange);
        return () => {
            mediaQuery.removeEventListener('change', handleSystemChange);
        };
    }, []);
    const changeTheme = (newMode) => {
        setThemeMode(newMode);
        localStorage.setItem('app-theme', newMode);
        const isDark = newMode === 'dark' || (newMode === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
        const newActual = isDark ? 'dark' : 'light';
        setActualTheme(newActual);
        document.documentElement.setAttribute('data-theme', newActual);
    };
    const changeStyle = (newStyle) => {
        setStyleMode(newStyle);
        localStorage.setItem('app-style', newStyle);
        document.documentElement.setAttribute('data-style', newStyle);
    };
    return {
        themeMode,
        styleMode,
        actualTheme,
        changeTheme,
        changeStyle
    };
}
